import { createContext, useContext } from 'react';

import { type MobileMainIdentifierValues } from 'bundles/composable-page-header/constants';

export type ToSubPage = (id: MobileMainIdentifierValues) => void;
export type ToParentPage = (id: MobileMainIdentifierValues) => void;

const MobileNavigationContext = createContext<{
  toSubPage?: ToSubPage;
  toParentPage?: ToParentPage;
  closeMobileMenu?: () => void;
  setIsOnSubNav?: (isOnSubNav: boolean) => void;
  onSubNav?: boolean;
}>({
  toSubPage: () => {},
  toParentPage: () => {},
  closeMobileMenu: () => {},
  setIsOnSubNav: (isOnSubNav: boolean) => {},
  onSubNav: false,
});

export const useMobileToSubPage = () => {
  return useContext(MobileNavigationContext).toSubPage;
};

export const useMobileToParentPage = () => {
  return useContext(MobileNavigationContext).toParentPage;
};

export const useCloseMobileMenu = () => {
  return useContext(MobileNavigationContext).closeMobileMenu;
};

export const useSetIsOnSubNav = () => {
  return useContext(MobileNavigationContext).setIsOnSubNav;
};

export const useGetOnSubNav = () => {
  return useContext(MobileNavigationContext).onSubNav;
};

export default MobileNavigationContext;
